import { Form } from '../form';
import { Description } from '../description-repex';
import { StepIntroProps } from '../../branded-consumer-loan';
import { useBrandedColors } from '../../hooks/use-branded-colors';
import clsx from 'clsx';

export const Intro = ({ calculator, common, getLabel, brandColor, ...rest }: StepIntroProps) => {
    const { commonTermsUrl, secciUrl } = common;
    const { useBrandedColorsBool } = useBrandedColors({ brandColor });

    return (
        <div className="r-flex r-flex-col r-items-center r-pt-1">
            <div className="r-w-full r-py-12">
                <div className="r-w-full r-space-y-12 r-pb-6 md:r-mx-auto md:r-max-w-xl md:r-px-4">
                    <h2 className={clsx('r-text-3xl r-font-bold', useBrandedColorsBool ? 'r-text-black' : 'r-text-primary-500')}>
                        {getLabel('calculatorTitle')}
                    </h2>
                </div>

                <Form getLabel={getLabel} brandColor={brandColor} {...calculator} {...rest} step={1000} />

                <Description
                    title={getLabel('descriptionTitle')}
                    text={getLabel('descriptionText')}
                    commonTermsTitle={getLabel('commonTerms')}
                    secciTitle={getLabel('secci')}
                    commonTermsUrl={commonTermsUrl?.url || ''}
                    secciUrl={secciUrl?.url || ''}
                    brandColor={brandColor}
                />
            </div>
        </div>
    );
};
